/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Company-DepartmentGrid .k-grid-content,.Company-DepartmentGrid .k-grid-content-locked{height:calc(100vh - 21rem);overflow:auto}"];
export { styles as styles };
